import request from '@/utils/request'

let StatisticsApi = {
  /*订单数据统计*/
  getOrderTotal(data, errorback) {
    return request._post('/shop/statistics.sales/index', data, errorback);
  },
  /*订单时间段统计*/
  getOrderByDate(data, errorback) {
    return request._post('/shop/statistics.sales/order', data, errorback);
  },
  /*商品时间段统计*/
  getProductByDate(data, errorback) {
    return request._post('/shop/statistics.sales/product', data, errorback);
  },
  /*会员数据统计*/
  getUserTotal(data, errorback) {
    return request._post('/shop/statistics.user/index', data, errorback);
  },
  /*成交占比*/
  getUserScale(data, errorback) {
    return request._post('/shop/statistics.user/scale', data, errorback);
  },
  /*新增会员*/
  getNewUser(data, errorback) {
    return request._post('/shop/statistics.user/new_user', data, errorback);
  },
  /*成交会员数*/
  getPayUser(data, errorback) {
    return request._post('/shop/statistics.user/pay_user', data, errorback);
  },
  /*供应商统计*/
  getSupplierTotal(data, errorback) {
    return request._post('/shop/statistics.supplier/index', data, errorback);
  },
  /*供应商时间段统计*/
  getSupplierByDate(data, errorback) {
    return request._post('/shop/statistics.supplier/data', data, errorback);
  },
  /*访问统计*/
  getAccessTotal(data, errorback) {
    return request._post('/shop/statistics.access/index', data, errorback);
  },
  /*访问时间段统计*/
  getAccessByDate(data, errorback) {
    return request._post('/shop/statistics.access/data', data, errorback);
  },
  // 技师统计合计
  getWaiterDate(data, errorback) {
    return request._get('/shop/statistics.Waiter/index', data, errorback);
  },
  // 技师统计
  getWaitertable(data, errorback) {
    return request._get('/shop/statistics.Waiter/data', data, errorback);
  },
  // 技师人员统计
  getHeader(data, errorback) {
    return request._get('/shop/statistics.Waiter/getHeader', data, errorback);
  },
  // 技师人员统计
  getWaiterperson(data, errorback) {
    return request._get('/shop/statistics.Waiter/excelData', data, errorback);
  },
  // ====================

  /*销售图标统计*/
  getsalesicon(data, errorback) {
    return request._get('/shop/statistics.sales/sales', data, errorback);
  },
  /*会员统计*/
  getusermember(data, errorback) {
    return request._get('/shop/statistics.user/index', data, errorback);
  },
  // 商户图表
  getsupThreeTable(data, errorback) {
    return request._get('/shop/statistics.Supplier/getThreeTable', data, errorback);
  },
  // 个体商户表
  getSupplierList(data, errorback) {
    return request._get('/shop/statistics.Supplier/getSupplierList', data, errorback);
  },

}

export default StatisticsApi;



// WEBPACK FOOTER //
// ./src/api/statistics.js